import api from '../utils/api';

export interface User {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  companyId: number;
  role: string;
  isActive: boolean;
  lastLoginAt: string;
  createdAt: string;
  updatedAt: string;
  company?: {
    id: number;
    name: string;
    siret: string;
    departement?: string;
    nafCodes?: string[];
  };
}

export interface Company {
  id: number;
  name: string;
  siret: string;
  address?: string;
  postalCode?: string;
  city?: string;
  departement?: string;
  country?: string;
  phone?: string;
  email?: string;
  website?: string;
  nafCodes?: string[];
  createdAt: string;
  updatedAt: string;
  userCount: number;
  adherentCount: number;
}

export const getAllUsers = async (): Promise<User[]> => {
  const response = await api.get('/admin/users');
  return response.data;
};

export const getAllCompanies = async (): Promise<Company[]> => {
  const response = await api.get('/admin/companies');
  return response.data;
};

export const impersonateUser = async (userId: number) => {
  const response = await api.post(`/admin/users/${userId}/impersonate`);
  return response.data;
};

export const toggleUserStatus = async (userId: number) => {
  const response = await api.post(`/admin/users/${userId}/toggle-status`);
  return response.data;
};

export const updateUser = async (userId: number, userData: Partial<User>): Promise<User> => {
  const response = await api.put(`/admin/users/${userId}`, userData);
  return response.data.user;
};

export const updateCompany = async (companyId: number, companyData: Partial<Company>): Promise<Company> => {
  const response = await api.put(`/admin/companies/${companyId}`, companyData);
  return response.data.company;
};

export const createUser = async (userData: Partial<User> & { password: string }): Promise<User> => {
  const response = await api.post('/admin/users', userData);
  return response.data.user;
};

export const createCompany = async (companyData: Partial<Company>): Promise<Company> => {
  const response = await api.post('/admin/companies', companyData);
  return response.data.company;
};

export const createClient = async (clientData: {
  company: Partial<Company>;
  user: Partial<User> & { password: string };
}): Promise<{ user: User; company: Company }> => {
  const response = await api.post('/admin/clients', clientData);
  return {
    user: response.data.user,
    company: response.data.company
  };
}; 